














import {Component, Vue, Watch} from "vue-property-decorator";
import { Circle2 } from "vue-loading-spinner";
import { fileOpen, fileDownload } from "@/file-utils";

import PaginatedSearch from "@/layouts/DashboardLayoutComponents/SoniprevPaginatedSearch.vue";
import ShiftFilter from "@/layouts/DashboardLayoutComponents/ShiftFilter.vue";

import reportModel from "@/models/report.model";
import FormField from "@/layouts/DashboardLayoutComponents/FormField.vue";

@Component({
	components: {
		ShiftFilter,
		PaginatedSearch,
		Circle2,
		FormField,
	},
})
export default class AccountabilityReport extends Vue {
	shiftModel: any;
	shiftFilter: Record<string, any> = {};
	shiftId: any = null;
	fileDownloading = false;

	valueType = "net"

	constructor() {
		super();
	}

	updateFilter(filter: any)  {
		console.log({ filter })
		this.shiftFilter = filter;
	}

	async getReport(kind: "DOWNLOAD" | "OPEN") {
		if (!this.validateForm()) {
			return
		}

		this.fileDownloading = true;
		try {
			const pdfBlob = await reportModel.getAccountabilityReport({
				sectorId: this.shiftFilter?.sector,
				specialtyId: this.shiftFilter['sector.specialty'],
				startDateTime: this.shiftFilter.startDateTime,
				professionalUserId: this.shiftFilter?.professionalUser,
				unitId: this.shiftFilter.unit,
			});
			if (kind === "DOWNLOAD") {
				fileDownload(pdfBlob, 'relatorio-contabilidade.xlsx');
			}
		} catch (error) {
			this.$toasted.error(error.friendlyMessage || 'Não foi possível gerar o relatório. Tente novamente.');
			console.error(error);
		}
		this.fileDownloading = false;
	}

	validateForm(): boolean {
		if (this.shiftFilter && !this.shiftFilter.unit) {
			this.$toasted.error('É necessário selecionar uma unidade para gerar o relatório');
			return false
		}
		return true
	}
}
